/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ModalInfoIcon - Auto-generated from icon.js
 */
export const ModalInfoIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_3096_21874)">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.5 1.90735e-06C7.6625 1.90735e-06 0.5 7.1625 0.5 16C0.5 24.8375 7.6625 32 16.5 32C25.3375 32 32.5 24.8375 32.5 16C32.5 7.1625 25.3375 1.90735e-06 16.5 1.90735e-06ZM16.5 6C17.0531 6 17.5 6.44687 17.5 7C17.5 7.55313 17.0531 8 16.5 8C15.9469 8 15.5 7.55313 15.5 7C15.5 6.44687 15.9469 6 16.5 6ZM19.4821 26H17.4509H15.4509H13.5134C12.9603 26 12.5134 25.5531 12.5134 25C12.5134 24.4469 12.9603 24 13.5134 24H15.4509V13.9219H13.4821C12.929 13.9219 12.4821 13.475 12.4821 12.9219C12.4821 12.3687 12.929 11.9219 13.4821 11.9219H15.4509H16.4509C17.004 11.9219 17.4509 12.3687 17.4509 12.9219V24H19.4821C20.0353 24 20.5134 24.4469 20.5134 25C20.5134 25.5531 20.0353 26 19.4821 26Z" fill="#3091FD" />
		</g>
		<defs>
			<clipPath id="clip0_3096_21874">
				<rect width="32" height="32" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export default ModalInfoIcon;
